import { useMutation } from '@tanstack/react-query';
import { ALERT_STATUS, useAlert } from '../../../contexts/AlertContext';

import { createRelatedFile } from '../../files';

const useCreateRelatedFile = (handleSuccess) => {
	const { handleAlert } = useAlert();

	const { mutateAsync: handleCreateRelatedFile, isPending } = useMutation({
		mutationFn: (data) => createRelatedFile(data),
		onSuccess: handleSuccess,
		onError: (error) => {
			handleAlert(ALERT_STATUS.ERROR, error.response.data.error);
		},
	});

	return { handleCreateRelatedFile, isPending };
};

export default useCreateRelatedFile;
